import React from 'react';
/**
 * A hook that assists in implementing navigation through a set of HTML elements
 * using the left/right arrow keys, the up/down arrow keys, or both.
 */
export function useArrowKeyNavigation(_a) {
    var 
    // Note that for this default selector to work, all navigable elements must have a `tabindex` attribute set
    // (i.e., do NOT just rely on the inherent tabbability of native elements like `button`).
    _b = _a.selector, 
    // Note that for this default selector to work, all navigable elements must have a `tabindex` attribute set
    // (i.e., do NOT just rely on the inherent tabbability of native elements like `button`).
    selector = _b === void 0 ? '[tabindex="0"],[tabindex="-1"]' : _b, _c = _a.supportLeftRightKeys, supportLeftRightKeys = _c === void 0 ? false : _c, _d = _a.supportUpDownKeys, supportUpDownKeys = _d === void 0 ? false : _d;
    // Refs
    var containerRef = React.useRef(null);
    // Callbacks
    var onKeyDown = React.useCallback(function (ev) {
        var _a;
        if (!(ev.target instanceof Element))
            return;
        // Avoid interfering with the arrow key navigation for an open menu.
        var isExpandedMenuTrigger = ev.target.getAttribute('aria-haspopup') === 'menu' && ev.target.getAttribute('aria-expanded') === 'true';
        var navigableEls = Array.from(((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector)) || []);
        var targetElIdx = navigableEls.findIndex(function (navigableEl) { return navigableEl === ev.target; });
        if (targetElIdx === -1)
            return;
        if ((supportUpDownKeys && ev.key === 'ArrowDown' && !isExpandedMenuTrigger) ||
            (supportLeftRightKeys && ev.key === 'ArrowRight')) {
            // Prevent the page from scrolling horizontally or vertically.
            ev.preventDefault();
            var nextEl = navigableEls[targetElIdx >= navigableEls.length - 1 ? 0 : targetElIdx + 1];
            if (nextEl instanceof HTMLElement)
                nextEl.focus();
        }
        else if ((supportUpDownKeys && ev.key === 'ArrowUp' && !isExpandedMenuTrigger) ||
            (supportLeftRightKeys && ev.key === 'ArrowLeft')) {
            // Prevent the page from scrolling horizontally or vertically.
            ev.preventDefault();
            var prevEl = navigableEls[targetElIdx <= 0 ? navigableEls.length - 1 : targetElIdx - 1];
            if (prevEl instanceof HTMLElement)
                prevEl.focus();
        }
    }, [selector, supportLeftRightKeys, supportUpDownKeys]);
    return { containerCallbacks: { onKeyDown: onKeyDown }, containerRef: containerRef };
}
